export default __webpack_public_path__ + "static/media/diners-logo.d03463d5.png";